import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Categorias } from 'src/app/shared/Interfaces/company';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  ex!: Categorias[]

  valueSharedSubject = new BehaviorSubject<Categorias[]>(this.ex);
  valueShared$ = this.valueSharedSubject.asObservable();

  private filterSubject = new BehaviorSubject<string>('');
  filter$ = this.filterSubject.asObservable();

  private activeInputSubject = new BehaviorSubject<boolean>(false);
  activeInput$ = this.activeInputSubject.asObservable();

  methodReceipt = new BehaviorSubject<boolean>(false);
  methodReceipt$ = this.methodReceipt.asObservable();
  constructor() { }

  updateActive(value: boolean){
    this.activeInputSubject.next(value);
  }

  updateFilter(value: string){
    this.filterSubject.next(value);
  }

  
}
